@if (embedded()) {
  <ng-container *ngTemplateOutlet="chatPage"></ng-container>
} @else {
  <app-page-layout>
    <div slot="children2" class="!p-0">
      <ng-container *ngTemplateOutlet="chatPage"></ng-container>
    </div>
  </app-page-layout>
}

<ng-template #chatPage>
  <div class="sp-chat-page !pb-0" [class.sp-chat-page--embedded]="embedded()">
    <div class="sp-chat-shell">
      @if (view() === 'thread') {
        <!-- Conversation header (only on the thread view; the welcome view
               renders its own hero with logo + close button) -->
        <div class="conv-head">
          <button class="conv-back" type="button" (click)="goBack()" aria-label="Volver">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m15 6-6 6 6 6" />
            </svg>
          </button>
          <div class="av admin-av">
            <img src="assets/images/logos/sm.png" alt="Superpay23" />
            @if (store.adminStatus() === 'inactive') {
              <span class="away" aria-label="Agente no activo">
                <svg
                  width="10"
                  height="10"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
                </svg>
              </span>
            } @else if (store.adminOnline()) {
              <span class="pres"></span>
            }
          </div>
          <div class="who">
            <div class="n">Soporte Superpay23</div>
            <div class="s">
              {{
                store.adminOnline() ? 'En línea · Especialista de pagos' : 'Soporte de pagos crypto'
              }}
            </div>
          </div>
          @if (embedded()) {
            <button
              class="conv-close"
              type="button"
              (click)="close.emit()"
              aria-label="Cerrar chat"
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M18 6L6 18M6 6l12 12" />
              </svg>
            </button>
          }
        </div>
      }

      @if (view() === 'welcome') {
        <div class="home-view" aria-label="Bienvenida al chat de soporte">
          <div class="home-hero">
            <div class="top-row">
              <app-sm-logo-white
                class="brand-logo"
                [width]="84"
                [height]="40"
                aria-label="Superpay23"
              ></app-sm-logo-white>
              <button class="x-close" type="button" (click)="goBack()" aria-label="Cerrar chat">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M18 6L6 18M6 6l12 12" />
                </svg>
              </button>
            </div>
            <h1>
              Hola{{ firstName() ? ' ' + firstName() : '' }}
              <span class="wave" aria-hidden="true">👋</span>
            </h1>
            <p class="lead">
              Soporte de Superpay23. Te ayudamos con cualquier transferencia, pago o movimiento de
              tu cuenta.
            </p>
            <div class="agent-strip">
              @if (store.adminStatus() === 'inactive') {
                <span class="sm">
                  <span class="green is-away" aria-hidden="true"></span>
                  Agente actualmente no disponible
                </span>
              } @else {
                <span class="sm">
                  <span class="green" aria-hidden="true"></span>
                  Tiempo de respuesta ~2 min
                </span>
              }
            </div>
          </div>

          <div class="home-cards">
            @if (store.hasConversation()) {
              <button
                type="button"
                class="home-card"
                (click)="enterThread()"
                aria-label="Reanudar conversación con soporte"
              >
                <div class="av-mini has-logo">
                  <img src="assets/images/logos/sm.png" alt="Superpay23" />
                  @if (store.adminStatus() === 'inactive') {
                    <span class="away" aria-label="Agente no activo">
                      <svg
                        width="9"
                        height="9"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
                      </svg>
                    </span>
                  } @else if (store.adminOnline()) {
                    <span class="pres" aria-hidden="true"></span>
                  }
                </div>
                <div style="flex: 1; min-width: 0">
                  <div class="label">Soporte Superpay</div>
                  <div class="sub">
                    {{ lastAdminPreview() || 'Conversación en curso' }}
                  </div>
                </div>
                @if (store.unreadCount() > 0) {
                  <div class="urg-badge" aria-label="Mensajes sin leer">
                    {{ store.unreadCount() > 99 ? '99+' : store.unreadCount() }}
                  </div>
                }
                <div class="arrow" aria-hidden="true">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="m9 6 6 6-6 6" />
                  </svg>
                </div>
              </button>
            } @else {
              <button
                type="button"
                class="home-card primary"
                (click)="enterThread()"
                aria-label="Iniciar conversación con soporte"
              >
                <div class="av-mini">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M12 5v14M5 12h14" />
                  </svg>
                </div>
                <div style="flex: 1; min-width: 0">
                  <div class="label">Iniciar conversación</div>
                  <div class="sub">Te conectamos con un especialista en ~2 min</div>
                </div>
                <div class="arrow" aria-hidden="true">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="m9 6 6 6-6 6" />
                  </svg>
                </div>
              </button>
            }
          </div>

          <div class="home-section">Preguntas frecuentes</div>
          <div class="home-faq">
            @for (topic of commonTopics(); track topic.question) {
              <div class="faq-item" [class.is-open]="expandedTopic() === topic.question">
                <button
                  type="button"
                  class="row"
                  (click)="toggleTopic(topic.question)"
                  [attr.aria-expanded]="expandedTopic() === topic.question"
                >
                  <span class="row-label">
                    <span class="row-ic" aria-hidden="true">
                      @switch (topic.icon) {
                        @case ('coin') {
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <circle cx="12" cy="12" r="9" />
                            <path d="M12 7v10M9 9.5h4.5a1.5 1.5 0 0 1 0 3H10a1.5 1.5 0 0 0 0 3h5" />
                          </svg>
                        }
                        @case ('percent') {
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path d="M19 5L5 19" />
                            <circle cx="7.5" cy="7.5" r="2.5" />
                            <circle cx="16.5" cy="16.5" r="2.5" />
                          </svg>
                        }
                        @case ('flask') {
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path d="M9 3h6" />
                            <path d="M10 3v6L5.5 17a2 2 0 0 0 1.7 3h9.6a2 2 0 0 0 1.7-3L14 9V3" />
                            <path d="M7.5 14h9" />
                          </svg>
                        }
                        @case ('receipt') {
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="1.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          >
                            <path d="M5 3v18l2-1.2 2 1.2 2-1.2 2 1.2 2-1.2 2 1.2V3l-2 1.2L15 3l-2 1.2L11 3 9 4.2 7 3z" />
                            <path d="M9 8h6M9 12h6" />
                          </svg>
                        }
                      }
                    </span>
                    {{ topic.question }}
                  </span>
                  <span class="chev" aria-hidden="true">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="m6 9 6 6 6-6" />
                    </svg>
                  </span>
                </button>
                @if (expandedTopic() === topic.question) {
                  <div class="faq-answer" role="region">
                    {{ topic.answer }}
                  </div>
                }
              </div>
            }
          </div>

          <div class="home-footnote">Superpay23 · Soporte</div>
        </div>
      }

      @if (view() === 'thread') {
        @if (searchOpen()) {
          <div class="conv-search-bar">
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="search-ic"
            >
              <circle cx="11" cy="11" r="8" />
              <path d="m21 21-4.3-4.3" />
            </svg>
            <input
              type="text"
              [ngModel]="searchQuery()"
              (ngModelChange)="onSearchInput($event)"
              placeholder="Buscar mensajes…"
              autocomplete="off"
            />
            @if (searching()) {
              <mat-spinner diameter="16"></mat-spinner>
            } @else if (searchQuery()) {
              <span class="search-count">
                {{ searchResults().length }} resultado{{ searchResults().length === 1 ? '' : 's' }}
              </span>
            }
          </div>
        }

        <!-- Thread -->
        <div
          #messagesContainer
          class="thread"
          (scroll)="onScroll()"
          role="log"
          aria-live="polite"
          aria-label="Conversación con soporte"
        >
          @if (store.loading() && displayMessages().length === 0) {
            <div class="thread-loading">
              <mat-spinner diameter="28"></mat-spinner>
            </div>
          }

          @if (store.hasMore() && displayMessages().length > 0) {
            <div class="thread-load-more">
              <button type="button" (click)="handleLoadMore()">Cargar mensajes anteriores</button>
            </div>
          }

          @if (searchOpen() && searchQuery().trim()) {
            <div class="search-results-list">
              @for (result of searchResults(); track result._id || result.id || $index) {
                <div class="search-result-item">
                  <div class="meta">
                    {{ result.sender === ChatSender.CUSTOMER ? 'Tú' : 'Soporte' }} ·
                    {{ formatTime(result.createdAt) }}
                  </div>
                  <div class="snippet">{{ result.text }}</div>
                </div>
              }
              @if (!searching() && searchResults().length === 0) {
                <div class="search-empty">Sin resultados.</div>
              }
            </div>
          }

          @if (!searchOpen() || !searchQuery().trim()) {
            @for (group of groupedDisplay(); track group.key) {
              <div class="day-divider">{{ group.label }}</div>
              @for (message of group.items; track trackMessage($index, message); let i = $index) {
                @if (message.kind === 'msg') {
                  <div
                    class="bubble-row"
                    [class.me]="message.from === 'me'"
                    [class.them]="message.from !== 'me'"
                    [class.same-as-prev]="message.sameAsPrev"
                    [class.same-as-next]="message.sameAsNext"
                    [class.has-audio]="hasAudioAttachment(message)"
                    [class.has-ticket]="!!message.ticket"
                    [attr.data-msg-id]="message._id || message.id || null"
                    [attr.aria-label]="
                      (message.from === 'me' ? 'Tú' : 'Soporte') +
                      ' a las ' +
                      formatTime(message.createdAt)
                    "
                  >
                    <div
                      class="av"
                      [class.admin-av]="message.from !== 'me'"
                      [class.user-av]="message.from === 'me'"
                      [style.visibility]="message.sameAsNext ? 'hidden' : 'visible'"
                    >
                      @if (message.from === 'me') {
                        <app-avatar [initials]="authStore.userInitials()" [size]="34"></app-avatar>
                      } @else {
                        <img src="assets/images/logos/sm.png" alt="Superpay23" />
                      }
                    </div>
                    <div>
                      @if (message.from !== 'me' && !message.sameAsPrev) {
                        <div class="sender-name">Soporte Superpay23</div>
                      }
                      @if (message.replyTo) {
                        <button
                          type="button"
                          class="reply-quote"
                          [class.me]="message.from === 'me'"
                          [class.them]="message.from !== 'me'"
                          (click)="scrollToMessage(message.replyTo._id)"
                          [attr.aria-label]="
                            'Respondiendo a ' +
                            replyPreviewLabel(message.replyTo) +
                            ': ' +
                            replyPreviewText(message.replyTo)
                          "
                        >
                          <div class="reply-quote-bar"></div>
                          <div class="reply-quote-body">
                            <div class="reply-quote-author">
                              {{ replyPreviewLabel(message.replyTo) }}
                            </div>
                            <div class="reply-quote-text">
                              {{ replyPreviewText(message.replyTo) }}
                            </div>
                          </div>
                        </button>
                      }
                      @if (message.attachments && message.attachments.length > 0) {
                        @for (att of message.attachments; track att.minioObjectKey || $index) {
                          @if (att.kind === AttachmentKind.AUDIO) {
                            <div
                              class="attach-audio"
                              [class.me]="message.from === 'me'"
                              [class.them]="message.from !== 'me'"
                              [class.sending]="message.status === ChatMessageStatus.SENDING"
                              #audioDiv
                              [attr.data-observe]="
                                !att.localPreviewUrl && att.minioObjectKey
                                  ? observeAttachment(audioDiv, att.minioObjectKey)
                                  : null
                              "
                            >
                              <app-audio-player
                                [src]="att.localPreviewUrl || attachmentHref(att.minioObjectKey)"
                                [durationSec]="att.durationSec"
                                [variant]="message.from === 'me' ? 'me' : 'them'"
                                [seed]="
                                  (message._id || message.id || message.localId || 'voice') +
                                  ':' +
                                  $index
                                "
                                [messageTime]="formatTime(message.createdAt)"
                                [messageStatus]="
                                  message.from === 'me'
                                    ? audioBubbleStatus(message.status)
                                    : undefined
                                "
                                (retry)="retryMessage(message)"
                                (firstPlay)="onAdminAudioPlayed(message)"
                              ></app-audio-player>
                            </div>
                          } @else if (
                            att.kind === AttachmentKind.IMAGE &&
                            (att.localPreviewUrl || att.minioObjectKey)
                          ) {
                            <button
                              type="button"
                              class="attach-img-link"
                              [class.sending]="message.status === ChatMessageStatus.SENDING"
                              (click)="openImage(att)"
                              [disabled]="openingAttachmentKey() === att.minioObjectKey"
                              [attr.aria-label]="att.originalName || 'Ver imagen'"
                              #imgBtn
                              [attr.data-observe]="
                                !att.localPreviewUrl && att.minioObjectKey
                                  ? observeAttachment(imgBtn, att.minioObjectKey)
                                  : null
                              "
                            >
                              <img
                                [src]="att.localPreviewUrl || attachmentHref(att.minioObjectKey)"
                                [alt]="att.originalName || 'Imagen'"
                                class="attach-img-real"
                              />
                              @if (message.status === ChatMessageStatus.SENDING) {
                                <div class="attach-img-overlay">
                                  <mat-spinner diameter="28" color="accent"></mat-spinner>
                                </div>
                              }
                            </button>
                          } @else if (att.kind === AttachmentKind.IMAGE) {
                            <div class="attach-img">
                              <span class="label">📷 Subiendo imagen…</span>
                            </div>
                          } @else {
                            <a
                              class="attach-card"
                              [attr.href]="fileAttachmentHref(att.minioObjectKey)"
                              [attr.target]="fileAttachmentHref(att.minioObjectKey) ? '_blank' : null"
                              rel="noopener"
                              (click)="onFileAttachmentClick($event, att.minioObjectKey)"
                            >
                              <div class="thumb">
                                <svg
                                  width="18"
                                  height="18"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="1.8"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                >
                                  <path
                                    d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                                  />
                                  <path d="M14 2v6h6" />
                                </svg>
                              </div>
                              <div class="info">
                                <div class="n">{{ att.originalName || 'Documento' }}</div>
                                <div class="s">{{ formatFileSize(att.sizeBytes) }}</div>
                              </div>
                            </a>
                          }
                        }
                      }

                      @if (message.ticket) {
                        <div class="bubble-ticket-wrap">
                          <app-recharge-ticket
                            [ticket]="message.ticket"
                            (markPaid)="onTicketMarkPaid(message)"
                            (viewDetails)="onTicketViewDetails(message)"
                          ></app-recharge-ticket>
                        </div>
                      }

                      @if (message.text) {
                        <div
                          class="bubble"
                          [class.me]="message.from === 'me'"
                          [class.them]="message.from !== 'me'"
                          [class.same-as-prev]="message.sameAsPrev"
                          [class.same-as-next]="message.sameAsNext"
                        >
                          <div class="bubble-text">
                            @for (seg of message.segments; track $index) {
                              @switch (seg.kind) {
                                @case ('text') {
                                  <span [innerHTML]="seg.value | linkify"></span>
                                }
                                @case ('inline-code') {
                                  <span class="inline-code-wrap">
                                    <code class="inline-code">{{ seg.value }}</code>
                                    <button
                                      type="button"
                                      class="code-copy-btn inline"
                                      (click)="copyToClipboard(seg.value)"
                                      aria-label="Copiar"
                                      title="Copiar"
                                    >
                                      <svg
                                        width="12"
                                        height="12"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      >
                                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                                        <path
                                          d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
                                        />
                                      </svg>
                                      <span>Copiar</span>
                                    </button>
                                  </span>
                                }
                                @case ('code-block') {
                                  <div class="code-block-wrap">
                                    <button
                                      type="button"
                                      class="code-copy-btn block"
                                      (click)="copyToClipboard(seg.value)"
                                      aria-label="Copiar"
                                      title="Copiar"
                                    >
                                      <svg
                                        width="13"
                                        height="13"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      >
                                        <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                                        <path
                                          d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
                                        />
                                      </svg>
                                      <span>Copiar</span>
                                    </button>
                                    <pre class="code-block"><code>{{ seg.value }}</code></pre>
                                  </div>
                                }
                              }
                            }
                          </div>
                          <span class="bubble-meta-inline">
                            @if (message.editedAt) {
                              <span
                                class="edited-tag"
                                [title]="'Editado · ' + formatTime(message.editedAt)"
                              >
                                editado
                              </span>
                            }
                            <span class="time">{{ formatTime(message.createdAt) }}</span>
                            @if (message.from === 'me') {
                              @switch (message.status) {
                                @case (ChatMessageStatus.SENDING) {
                                  <span class="status-ic" title="Enviando…">
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="1.8"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    >
                                      <circle cx="12" cy="12" r="9" />
                                      <path d="M12 7v5l3 2" />
                                    </svg>
                                  </span>
                                }
                                @case (ChatMessageStatus.SENT) {
                                  <span class="status-ic" title="Enviado">
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="1.8"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    >
                                      <path d="m5 14 3.5 3.5L19 6.5" />
                                    </svg>
                                  </span>
                                }
                                @case (ChatMessageStatus.DELIVERED) {
                                  <span class="status-ic" title="Entregado">
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="1.8"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    >
                                      <path d="m5 14 3.5 3.5L19 6.5" />
                                    </svg>
                                  </span>
                                }
                                @case (ChatMessageStatus.READ) {
                                  <span class="status-ic check-row read" title="Leído">
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="1.8"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    >
                                      <path
                                        d="M2.5 13.833L6 17.5l1.024-1.073M16.5 6.5l-6.063 6.352m-2.937.981L11 17.5l10.5-11"
                                      />
                                    </svg>
                                  </span>
                                }
                                @case (ChatMessageStatus.FAILED) {
                                  <span class="status-ic failed" title="Error al enviar">
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="1.8"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                    >
                                      <circle cx="12" cy="12" r="9" />
                                      <path d="M12 8v5" />
                                      <circle cx="12" cy="16" r="0.6" fill="currentColor" />
                                    </svg>
                                  </span>
                                  <button
                                    type="button"
                                    class="retry-btn"
                                    (click)="retryMessage(message)"
                                    [disabled]="store.sending()"
                                    aria-label="Reintentar envío"
                                  >
                                    <svg
                                      width="12"
                                      height="12"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="2"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      aria-hidden="true"
                                    >
                                      <path d="M3 12a9 9 0 1 0 3-6.7" />
                                      <path d="M3 4v5h5" />
                                    </svg>
                                    Reintentar
                                  </button>
                                }
                              }
                            }
                          </span>
                        </div>
                      } @else if (
                        message.attachments &&
                        message.attachments.length > 0 &&
                        !hasAudioAttachment(message)
                      ) {
                        <!-- Attachment-only message: meta overlay below.
                             Audio messages render the time + status INSIDE
                             the bubble via app-audio-player, so we skip this
                             strip for them to avoid a duplicated clock. -->
                        <div class="bubble-meta">
                          @if (message.editedAt) {
                            <span
                              class="edited-tag"
                              [title]="'Editado · ' + formatTime(message.editedAt)"
                            >
                              editado
                            </span>
                          }
                          <span>{{ formatTime(message.createdAt) }}</span>
                          @if (message.from === 'me') {
                            @switch (message.status) {
                              @case (ChatMessageStatus.SENDING) {
                                <span class="status">Enviando…</span>
                              }
                              @case (ChatMessageStatus.SENT) {
                                <span class="status">Enviado</span>
                              }
                              @case (ChatMessageStatus.DELIVERED) {
                                <span class="check-row" title="Entregado">
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="1.8"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  >
                                    <path d="m5 14 3.5 3.5L19 6.5" />
                                  </svg>
                                </span>
                              }
                              @case (ChatMessageStatus.READ) {
                                <span class="check-row read" title="Leído">
                                  <svg
                                    width="18"
                                    height="18"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="1.8"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                  >
                                    <path
                                      d="M2.5 13.833L6 17.5l1.024-1.073M16.5 6.5l-6.063 6.352m-2.937.981L11 17.5l10.5-11"
                                    />
                                  </svg>
                                </span>
                              }
                              @case (ChatMessageStatus.FAILED) {
                                <span class="status failed" title="Error al enviar">Error</span>
                                <button
                                  type="button"
                                  class="retry-btn"
                                  (click)="retryMessage(message)"
                                  [disabled]="store.sending()"
                                  aria-label="Reintentar envío"
                                >
                                  <svg
                                    width="12"
                                    height="12"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    aria-hidden="true"
                                  >
                                    <path d="M3 12a9 9 0 1 0 3-6.7" />
                                    <path d="M3 4v5h5" />
                                  </svg>
                                  Reintentar
                                </button>
                              }
                            }
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
              }
            }
          }

          @if (store.adminTyping() && !store.conversationClosed()) {
            <div class="typing">
              <div class="av admin-av">
                <img src="assets/images/logos/sm.png" alt="Superpay23" />
              </div>
              <div class="bub">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          }

          @if (store.conversationClosed()) {
            <div class="closed-banner">
              <div class="closed-banner-icon">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.8"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                  <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                </svg>
              </div>
              <div class="closed-banner-body">
                <div class="closed-banner-title">Esta conversación fue marcada como cerrada.</div>
                <button
                  type="button"
                  class="closed-banner-cta"
                  (click)="onStartNewConversation()"
                  [disabled]="store.startingNewConversation()"
                >
                  @if (store.startingNewConversation()) {
                    <mat-spinner diameter="16"></mat-spinner>
                    <span>Iniciando…</span>
                  } @else {
                    <span>Iniciar nueva conversación</span>
                  }
                </button>
              </div>
            </div>
          }
        </div>

        @if (showScrollFab()) {
          <button
            type="button"
            class="scroll-to-bottom-fab"
            (click)="jumpToBottom()"
            aria-label="Ir al último mensaje"
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="m6 9 6 6 6-6" />
            </svg>
            @if (newMessagesInFab() > 0) {
              <span class="badge">
                {{ newMessagesInFab() > 99 ? '99+' : newMessagesInFab() }}
              </span>
            }
          </button>
        }

        <!-- Composer -->
        <div class="composer" [class.is-closed]="store.conversationClosed()">
          @if (editingMessageId()) {
            <div class="edit-banner">
              <span>Editando mensaje</span>
              <button type="button" (click)="cancelEdit()" aria-label="Cancelar edición">
                Cancelar
              </button>
            </div>
          }

          @if (pickedFiles().length > 0) {
            <div class="composer-attached">
              @for (item of pickedFiles(); track $index; let i = $index) {
                <div class="chip">
                  @if (item.previewUrl) {
                    <img [src]="item.previewUrl" class="chip-thumb" alt="preview" />
                  } @else {
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.8"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                      <path d="M14 2v6h6" />
                    </svg>
                  }
                  <span class="chip-name">{{ item.file.name }}</span>
                  <span class="chip-size">· {{ formatFileSize(item.file.size) }}</span>
                  <span class="x" (click)="clearPickedFile(i)" aria-label="Quitar archivo">
                    <svg
                      width="11"
                      height="11"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2.4"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M18 6L6 18M6 6l12 12" />
                    </svg>
                  </span>
                </div>
              }
            </div>
          }

          <div class="composer-input-wrap">
            <input
              #fileInput
              type="file"
              accept="image/jpeg,image/png,image/webp,application/pdf"
              multiple
              (change)="onPickFile($event)"
              class="hidden-file"
            />

            @if (recordingState() === 'recording') {
              <!-- Active recording: pulsing red dot + timer + cancel button -->
              <div class="composer-recording" role="status" aria-live="polite">
                <span class="rec-dot" aria-hidden="true"></span>
                <span class="rec-clock">{{ formatRecordingClock(recordingElapsedMs()) }}</span>
                <span class="rec-hint">Grabando…</span>
                <button
                  type="button"
                  class="icon-btn rec-cancel"
                  (click)="cancelRecording()"
                  aria-label="Cancelar grabación"
                  title="Cancelar"
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M3 6h18" />
                    <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                  </svg>
                </button>
                <button
                  type="button"
                  class="send-btn"
                  (click)="toggleRecording()"
                  aria-label="Detener grabación"
                  title="Detener"
                >
                  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <rect x="6" y="6" width="12" height="12" rx="2" />
                  </svg>
                </button>
              </div>
            } @else if (recordingState() === 'preview') {
              <!-- Preview the captured clip before sending -->
              <div class="composer-rec-preview">
                <button
                  type="button"
                  class="icon-btn rec-cancel"
                  (click)="discardPreview()"
                  aria-label="Descartar grabación"
                  title="Descartar"
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M3 6h18" />
                    <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                  </svg>
                </button>
                @if (recordingPreviewUrl()) {
                  <audio
                    controls
                    preload="metadata"
                    [src]="recordingPreviewUrl()!"
                    class="rec-preview-audio"
                  ></audio>
                }
                <button
                  type="button"
                  class="send-btn"
                  (click)="sendRecording()"
                  [disabled]="store.sending()"
                  aria-label="Enviar grabación"
                >
                  @if (store.sending()) {
                    <mat-spinner diameter="20" color="accent"></mat-spinner>
                  } @else {
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
                      <path
                        d="M20.04 2.323c1.016-.355 1.992.621 1.637 1.637l-5.925 16.93c-.385 1.098-1.915 1.16-2.387.097l-2.859-6.432l4.024-4.025a.75.75 0 0 0-1.06-1.06l-4.025 4.024l-6.432-2.859c-1.063-.473-1-2.002.097-2.387z"
                      />
                    </svg>
                  }
                </button>
              </div>
            } @else {
              <button
                type="button"
                class="icon-btn"
                (click)="openFilePicker()"
                [disabled]="store.sending() || editingMessageId() !== null"
                aria-label="Adjuntar archivo"
                title="Adjuntar archivo"
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M21.4 11.05 12.5 19.95a5 5 0 0 1-7.07-7.07l9.19-9.19a3.5 3.5 0 1 1 4.95 4.95l-9.2 9.19a2 2 0 1 1-2.83-2.83l8.49-8.49"
                  />
                </svg>
              </button>

              <textarea
                #composerTextarea
                [ngModel]="draft()"
                (ngModelChange)="onDraftChange($event)"
                (keydown)="onKeydown($event)"
                (paste)="onPaste($event)"
                rows="1"
                maxlength="4000"
                [placeholder]="editingMessageId() ? 'Editar mensaje…' : 'Escribe tu mensaje…'"
              ></textarea>

              @if (!editingMessageId() && !draft().trim() && pickedFiles().length === 0) {
                <!-- Mic button replaces the send button while the composer is
                     empty. Tapping starts the MediaRecorder flow. -->
                <button
                  type="button"
                  class="icon-btn mic-btn"
                  (click)="toggleRecording()"
                  [disabled]="store.sending()"
                  aria-label="Grabar nota de voz"
                  title="Grabar nota de voz"
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
                    <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
                    <path d="M12 19v4" />
                  </svg>
                </button>
              } @else {
                <button
                  type="button"
                  class="send-btn"
                  (click)="onSubmit()"
                  [disabled]="store.sending() || (!draft().trim() && pickedFiles().length === 0)"
                  aria-label="Enviar"
                >
                  @if (store.sending()) {
                    <mat-spinner diameter="20" color="accent"></mat-spinner>
                  } @else {
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
                      <path
                        d="M20.04 2.323c1.016-.355 1.992.621 1.637 1.637l-5.925 16.93c-.385 1.098-1.915 1.16-2.387.097l-2.859-6.432l4.024-4.025a.75.75 0 0 0-1.06-1.06l-4.025 4.024l-6.432-2.859c-1.063-.473-1-2.002.097-2.387z"
                      />
                    </svg>
                  }
                </button>
              }
            }
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>
